import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Location } from 'Util/Location';

// async components
import {
  AsyncUserListComponent,
  AsyncUserDetailComponent,
  AsyncUserCreateComponent,
  AsyncUserModifyComponent,
  AsyncFavoriteComponent,
  AsyncMeComponent,
} from 'Components/AsyncComponent/AsyncComponent';

const Order = props => (
  <div className="content-wrapper">
    {props.location.pathname === '/admin/setting' && <Navigate to="me" />}
    {/* {props.location.pathname === '/admin/setting/user' && <Navigate to="user/list" />} */}
    <Routes>
      <Route path="user/list" element={<AsyncUserListComponent />} />
      <Route path="user/detail/:id" element={<AsyncUserDetailComponent />} />
      <Route path="user/create" element={<AsyncUserCreateComponent />} />
      <Route path="user/modify/:id" element={<AsyncUserModifyComponent />} />
      <Route path="favorite" element={<AsyncFavoriteComponent />} />
      <Route path="me" element={<AsyncMeComponent />} />
    </Routes>
  </div>
);

export default Location(Order);
